import type { FC } from 'react';
import { useState } from 'react';
import { message, Modal } from 'antd';
import { deleteCategory } from '@/services/api/categoryService';
import { useTranslation } from 'react-i18next';
import { Category } from '@/types/categories/category';

interface DeleteModalProps {
  category: Category | null;
  open: boolean;
  onCancel: () => void;
  onLoadData: () => void;
}

const ModalDeleteCategory: FC<DeleteModalProps> = ({
  category,
  open,
  onCancel,
  onLoadData,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOk = async () => {
    if (!category?.id) {
      message.error(t('home.categories.modals.delete.error'));
      return;
    }

    setIsLoading(true);
    try {
      const response = await deleteCategory(category.id);
      if (!response.success) {
        message.error(
          response.error || t('home.categories.modals.delete.error'),
        );
        setIsLoading(false);
        return;
      }
      message.success(t('home.categories.modals.delete.success'));
      onLoadData();
      onCancel();
    } catch (error) {
      message.error(t('home.categories.modals.delete.error'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={t('home.categories.modals.delete.title')}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      cancelText={t('home.categories.modals.delete.cancel')}
      okText={t('home.categories.modals.delete.confirm')}
      okType="danger"
      okButtonProps={{
        style: {
          color: 'white',
          backgroundColor: '#FF4D4F',
          borderColor: '#FF4D4F',
        },
      }}
      confirmLoading={isLoading}
    >
      <b>
        {t('home.categories.modals.delete.content', {
          categoryName: category?.name,
        })}
      </b>
    </Modal>
  );
};

export default ModalDeleteCategory;
